class CollectionCards extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('[data-cc-list]');
    this.prev = this.querySelector('[data-cc-prev]');
    this.next = this.querySelector('[data-cc-next]');
    if (!this.list) return;

    var self = this;

    if (this.prev) {
      this.prev.addEventListener('click', function () { self.scrollByCard(-1); });
    }
    if (this.next) {
      this.next.addEventListener('click', function () { self.scrollByCard(1); });
    }

    this.onScroll = function () { self.update(); };
    this.list.addEventListener('scroll', this.onScroll, { passive: true });

    if ('ResizeObserver' in window) {
      this.ro = new ResizeObserver(function () { self.update(); });
      this.ro.observe(this.list);
    } else {
      window.addEventListener('resize', this.onScroll);
    }

    this.update();
  }

  disconnectedCallback() {
    if (this.list && this.onScroll) this.list.removeEventListener('scroll', this.onScroll);
    if (this.ro) this.ro.disconnect();
  }

  step() {
    var item = this.list.querySelector('.cc__item');
    if (!item) return this.list.clientWidth;
    var gap = parseFloat(getComputedStyle(this.list).columnGap || '0') || 0;
    return item.getBoundingClientRect().width + gap;
  }

  scrollByCard(dir) {
    this.list.scrollBy({ left: this.step() * dir, behavior: 'smooth' });
  }

  update() {
    var max = this.list.scrollWidth - this.list.clientWidth;
    var x = this.list.scrollLeft;
    var overflows = max > 2;
    if (this.prev) this.prev.hidden = !overflows || x <= 2;
    if (this.next) this.next.hidden = !overflows || x >= max - 2;
  }
}

if (!customElements.get('collection-cards')) {
  customElements.define('collection-cards', CollectionCards);
}
